import StatsConfig from "./StatsConfig";
import AuthService from "../auth/AuthService"
import moment from "moment"
export default class UserService {
  /******* STATS **********/
  static getStatsByClient(filter, order,app) {  
    console.log("PARAMS getStatsByClient", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByClient;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id),
          evtId:filter.evtId,
          tktType:filter.tktType
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByClient", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static exportStatsByClient(filter, order,app) {  
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByClientExport;
        let filterBody = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id),
          evtId:filter.evtId,
          tktType:filter.tktType
        }
        let filePath = await StatsConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App:app },
          body: JSON.stringify({filter:filterBody,order:order})
      });
      if(filePath.ok()){
        let response = await StatsConfig.FirebaseConnector.getDownloadURL(
          filePath.body.filename
        );
        console.log(" >>>>>>>>>> res ok download", response);
        resolve(response)
      }else{
        throw filePath
      }
      }catch(e){
        reject(e)
      }
    });
  }

  static getStatsByClientDetail(filter, order,app) {  
    console.log("PARAMS getStatsByClientDetail", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByClientDetail;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          tktBuyerDU:filter.tktBuyerDU
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByClient", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
 
  static getStatsByEvent(filter, order,app) {  
    console.log("PARAMS getStatsByEvent", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByEvent;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id)
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByEvent", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static exportStatsByEvent(filter, order,app) {  

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByEventExport;
        let filterBody = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id),
        }
        let filePath = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({filter:filterBody,order:order})
        });
        if(filePath.ok()){
          let response = await StatsConfig.FirebaseConnector.getDownloadURL(
            filePath.body.filename
          );
          console.log(" >>>>>>>>>> res ok download", response);
          resolve(response)
        }else{
          throw filePath
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getStatsByRRPP(filter, order,app) {  
    console.log("PARAMS getStatsByRRPP", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByRRPP;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id)
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByRRPP", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static exportStatsByRRPP(filter, order,app) {  
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByRRPPExport;
        let filterBody = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          user:filter.user,
          tags:filter.tags && filter.tags.map((t)=>t.id)
        }
        let filePath = await StatsConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App:app },
          body: JSON.stringify({filter:filterBody,order:order})
        });
        if(filePath.ok()){
          let response = await StatsConfig.FirebaseConnector.getDownloadURL(
            filePath.body.filename
          );
          console.log(" >>>>>>>>>> res ok download", response);
          resolve(response)
        }else{
          throw filePath
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getStatsByRRPPDetail(filter, order,app) {  
    console.log("PARAMS getStatsByRRPPDetail", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByRRPPDetail;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.status,
          onlyGift:filter.onlyGift,
          tktRrpp:filter.tktRrpp
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByRRPPDetail", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/provider/stats/StatsService.js